// courses/course_A03.ts

export const course_A03 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 촬영 대기실 환경 조성: "배우의 안식처 만들기"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">대기실은 배우가 감정을 잡고 휴식을 취하는 유일한 공간입니다. 매니저는 이 공간을 최적의 상태로 유지해야 합니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>온도와 습도 관리:</strong> 여름에는 냉방, 겨울에는 난방 기구(핫팩, 가습기 등)를 미리 세팅하여 배우의 목소리와 피부 상태를 보호합니다.</li>
      <li style="margin-bottom: 8px;"><strong>프라이버시 보호:</strong> 외부 스태프나 팬들이 허락 없이 들어오지 않도록 문 앞을 지키거나 적절히 통제합니다.</li>
      <li><strong>청결 유지:</strong> 배우가 사용한 물병, 간식 쓰레기 등을 수시로 치워 쾌적한 환경을 유지합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 핵심 체크리스트 ①: 대본 관리</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>최신 버전 확인:</strong> 수정 대본(쪽대본)이 나왔는지 수시로 확인하여 배우에게 즉시 전달합니다.</li>
      <li style="margin-bottom: 8px;"><strong>대본 보안:</strong> 현장에서 대본을 분실하면 스포일러 유출 등 큰 문제가 생길 수 있습니다. 촬영이 끝나면 반드시 수거합니다.</li>
      <li><strong>형광펜과 필기도구:</strong> 배우가 대사를 체크하거나 동선을 적을 수 있도록 항상 필기구를 구비하여 곁에 둡니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 핵심 체크리스트 ②: 의상 및 분장 관리</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>착장 번호 확인:</strong> 드라마나 영화는 신(Scene) 순서대로 찍지 않습니다. 현재 찍는 장면이 몇 번 의상인지 스타일리스트와 함께 더블 체크합니다.</li>
      <li style="margin-bottom: 8px;"><strong>오염 방지:</strong> 식사나 이동 중에 의상이 더러워지지 않도록 턱받침이나 가운을 준비합니다.</li>
      <li><strong>수정 메이크업 요청:</strong> 조명 아래서 땀이 나거나 머리가 흐트러지면, 매니저가 먼저 발견하고 분장팀에 정중히 수정을 요청합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 핵심 체크리스트 ③: 컨디션 및 건강 관리</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>수분 섭취:</strong> 배우가 목이 마르지 않게 미지근한 물을 상시 대기시킵니다. (빨대를 꽂아 메이크업이 지워지지 않게 합니다.)</li>
      <li style="margin-bottom: 8px;"><strong>상비약 구비:</strong> 갑작스러운 두통, 소화불량, 상처 등에 대비해 구급함을 차량이나 가방에 항상 소지합니다.</li>
      <li><strong>감정 케어:</strong> 감정 소모가 큰 감정 신(Scene) 전후에는 배우가 몰입할 수 있도록 말을 아끼고 조용한 환경을 만들어줍니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">5. 왜 체크리스트가 필요한가?</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>실수의 최소화:</strong> 현장은 정신없이 바쁘기 때문에 머리로만 기억하면 반드시 놓치는 것이 생깁니다. 자신만의 체크리스트를 만들어 하나씩 지워가며 일하는 습관이 필요합니다.</li>
      <li><strong>배우와의 신뢰 구축:</strong> 매니저가 묻지 않아도 필요한 것을 미리 챙겨줄 때, 배우는 매니저를 전적으로 신뢰하고 연기에만 몰입할 수 있게 됩니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "매니저의 꼼꼼한 체크리스트 한 줄이 배우의 NG를 줄이고, 작품의 완성도를 높입니다."
    </p>
  </div>
`;